export const CART_TEST_IDS = {
  checkout: 'checkout',
  orderTypeDropDownBtn: 'order-type',
  pickupTimeDropDownBtn: 'pickup-time',
  scheduledOrderDropDownBtn: 'scheduled-order',
  orderTypeDropDown: 'order-type-dropdown',
  pickupOrderType: 'pickup',
  curbsideOrderType: 'curbside',
  deliveryOrderType: 'delivery',
  note: 'note',
  tableNumber: 'table-number',
  header: 'cart-header',
  specialInstructions: 'special-instructions'
};
